import React from 'react';
import { Modal, Button } from 'react-bootstrap';

// styles.
import { WrapperModal } from './styles';

interface ModalLayoutlProps {
  icon?: string;
  show: boolean;
  handleClose: () => void;
  handleSave: () => void;
  title: string;
  subtitle?: string;
  description: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

export const ModalLayout = ({
  icon,
  show,
  children,
  handleClose,
  handleSave,
  title,
  subtitle,
  description,
  disabled,
}: ModalLayoutlProps) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <WrapperModal>
        <Modal.Header className="d-flex p-4 border-bottom-0">
          <Modal.Title className="d-flex gap-3">
            {icon && <img src={icon} alt="icon" width="24px" />}
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-1 p-0 pb-4">
          <p className="px-4 pb-4 fw-bold subtitle">{subtitle}</p>
          <p className="px-4 description">{description}</p>
          {children && <div className="px-4">{children}</div>}
        </Modal.Body>
        <Modal.Footer className="d-flex flex-nowrap px-4 pb-4 border-top-0">
          <Button className="w-100 btn-habi-white" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            className="w-100 btn-habi"
            disabled={disabled}
            onClick={handleSave}
          >
            Realizar cambio
          </Button>
        </Modal.Footer>
      </WrapperModal>
    </Modal>
  );
};
